// extracted by mini-css-extract-plugin
export default {"select-pill-wrapper":"styles_select-pill-wrapper__Y6hig","arrow-right-icon":"styles_arrow-right-icon__LMAuI","div-pill":"styles_div-pill__q7jB0","versus":"styles_versus__2vmsw"};